// Comparator functions for sorting table columns

export const compareArrayLength = (rowA, rowB, id) => {
	let a = (rowA.values[id] && rowA.values[id].length) ?? -1;
	let b = (rowB.values[id] && rowB.values[id].length) ?? -1;
	if (a === b) {
		a = rowA.values[id] && rowA.values[id][0];
		b = rowB.values[id] && rowB.values[id][0];
	}
	if (a > b) return 1;
	if (a < b) return -1;
	return 0;
};

export const compareLicenceArrayLength = (rowA, rowB, id) => {
	let a = rowA.values[id] && rowA.values[id].length;
	let b = rowB.values[id] && rowB.values[id].length;
	if (a === b) {
		a = rowA.values[id] && rowA.values[id][0]?.subscription?.name;
		b = rowB.values[id] && rowB.values[id][0]?.subscription?.name;
	}
	if (a > b) return 1;
	if (a < b) return -1;
	return 0;
};

export const compareBooleans = (rowA, rowB, id) => {
	let a = rowA.values[id];
	let b = rowB.values[id];
	if (a < b) return 1;
	return -1;
};

export const compareUsers = (rowA, rowB, id) => {
	let {
		firstName: firstNameA,
		lastName: lastNameA,
		email: emailA,
	} = rowA.values[id];
	let {
		firstName: firstNameB,
		lastName: lastNameB,
		email: emailB,
	} = rowB.values[id];

	const totalNameA =
		`${firstNameA?.trim() || ""} ${lastNameA?.trim() || ""}`.toLowerCase();
	const totalNameB =
		`${firstNameB?.trim() || ""} ${lastNameB?.trim() || ""}`.toLowerCase();

	if (totalNameA === totalNameB) {
		if ((emailA?.trim() || "") > (emailB?.trim() || "")) {
			return 1;
		} else {
			return -1;
		}
	} else if (totalNameA > totalNameB) {
		return 1;
	} else {
		return -1;
	}
};
